module.exports = __webpack_public_path__ + "img/L4.0ad03b64.png";